// Text helpers

export const capitalize = (string?: string) => {
    if (!string || string.length === 0) return string
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const capitalizeWords = (string?: string) => {
    if (!string) return string;
    return string.replace(/\b\w/g, (char: string) => char.toUpperCase());
};

export const snakeToCamel = (string: string) => {
    return string.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

export const snakeToCapitalizedWords = (str: string): string => {
    return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

/**
 * Converts a string to snake_case, replacing any spaces with underscores and converting to lowercase.
 * Checks if camelCase or PascalCase and converts to snake_case.
 * Also handles special characters by removing them.
 * 
 * @param str The string to convert.
 * @returns The snake_case version of the string.
 */
export const toSnakeCase = (str: string): string => {
    // Convert camelCase or PascalCase to snake_case
    const snakeCased = str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    
    // Replace spaces with underscores and remove special characters
    return snakeCased.replace(/[^a-z0-9_]+/g, '_').replace(/_+/g, '_').replace(/^_+|_+$/g, '');
}